import { isExistFeatureFlag } from '@/service/feature/isExistFeatureFlag';
import { isBetaFacility } from '@/service/facility/isBetaFacility';

const FEATURE_KEY = 'useContactV3Api';

export const isContactV3ApiBetaEnabled = async (): Promise<boolean> => {
  const [hasFlag, isBeta] = await Promise.all([isExistFeatureFlag(FEATURE_KEY), isBetaFacility(FEATURE_KEY)]);
  return hasFlag && isBeta;
};
